import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  companies: [
    {
      company: null,
      age: null,
      propertyValuation: null,
      calculatedAmount: null,
    },
  ],
};

const reverseMortgageSlice = createSlice({
  name: 'reverseMortgage',
  initialState,
  reducers: {
    updateReverseMortgage: (state, action) => ({ ...state, ...{ companies: [...action.payload] } }),
    resetReverseMortgage: () => initialState,
  },
});

export const { updateReverseMortgage, resetReverseMortgage } = reverseMortgageSlice.actions;
export default reverseMortgageSlice.reducer;
